export default __webpack_public_path__ + "images/deepecho_icon.f9983f44340f3d227b877a9275436c9e.png";